// Form.js
import React, { useState } from 'react';
import { Container, TextField, Button, Grid, MenuItem, Select, InputLabel, FormControl, Typography } from '@mui/material';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import ModalAlert from './modal';

const Form = () => {

  const [modalOpen, setModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState('');

  const showAlert = (message) => {
    setModalMessage(message);
    setModalOpen(true);
  };

  const handleClose = () => {
    setModalOpen(false);
    setModalMessage('');
  };

  const navigate = useNavigate();

  const [tel, setTel] = useState('');
  const [pass, setPass] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();


    if(tel == ''){
      showAlert("연락처를 입력해주세요.");
      return;
    }

    if(pass == ''){
      showAlert("비밀번호를 입력해주세요.");
      return;
    }

    const formData = new FormData();
    formData.append('tel', tel);
    formData.append('pass', pass);


    try {
      const response = await axios.post('http://13.124.203.56/sungpt/get_user.php', formData, {
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      });
      console.log('Server response:', response.data);

      const count = response.data.count;
      // const id = response.data.id;

      if(count != false){
        navigate(`/checkapply2?id=${count}`);

        // navigate('/Suncheck2?id=${count}'); // 이동할 페이지의 상대 경로
      }else{
        showAlert("입력 정보를 확인해주세요.");
      }

    } catch (error) {

      console.error('There was an error uploading the form!', error);
    }
  };

  return (
    <Container component="main" maxWidth="xs"
      sx={{mt: 4}}>
      <div>
      <ModalAlert
        open={modalOpen}
        onClose={handleClose}
        message={modalMessage}
        />
        <form onSubmit={handleSubmit} noValidate>

        <div style={{
          display: 'flex',
          alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column'}}>
          <Typography variant="h5" gutterBottom sx={{ textAlign: 'center'}}>
            신청 정보를 입력해주세요.
          </Typography>

        </div>


            <Grid item xs={12} sx={{mt:4, mb: 2}}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="연락처"
                type="tel"
                value={tel}
                inputProps={{ maxLength: 11 }}
                onChange={(e) => setTel(e.target.value)}
              />
            </Grid>

            <Grid item xs={12} sx={{mb: 4}}>
              <TextField
                variant="outlined"
                required
                fullWidth
                label="신청확인 비밀번호 4자리"
                type="tel"
                value={pass}
                inputProps={{ maxLength: 4 }} // 최대 글자 수를 10자로 제한
                onChange={(e) => setPass(e.target.value)}
              />
            </Grid>


          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            sx={{ mt: 20, mb: 2 }}
            sx={{height:'50px', backgroundColor: '#f50057', color: '#fff', '&:hover': { backgroundColor: '#ff4081' } }}
          >
            확인
          </Button>
        </form>
      </div>
    </Container>
  );
};

export default Form;
